/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_LeadInputs */



/**
* | output |
* | --- |
* | "Tell us about the vessel and what you need." |
*
* @param {Contact_LeadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_lead = /** @type {((inputs?: Contact_LeadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_LeadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("告诉我们船舶情况和您的需求。")
	return /** @type {LocalizedString} */ ("Tell us about the vessel and what you need.")
});